export enum DATA_QA {
  ROOT = 'phone-edit',
  CLOSE_BUTTON = 'phone-edit__close-button',
  PHONE_NUMBER_INPUT = 'phone-edit__phone-number-input',
  DNC_SELECT = 'phone-edit__dnc-select',
  DNC_EXPIRES_CHECKBOX = 'phone-edit__dnc-expires-checkbox',
  DNC_OPT_OUT_DATE = 'phone-edit__dnc-opt-out-date',
  DNC_EXPIRATION_DATE = 'phone-edit__dnc-expiration-date',
  DNC_SCOPE_SELECT = 'phone-edit__dnc-scope-select',
  DNT_SELECT = 'phone-edit__dnt-select',
  DNT_EXPIRES_CHECKBOX = 'phone-edit__dnt-expires-checkbox',
  DNT_OPT_OUT_DATE = 'phone-edit__dnt-opt-out-date',
  DNT_EXPIRATION_DATE = 'phone-edit__dnt-expiration-date',
  DNT_SCOPE_SELECT = 'phone-edit__dnt-scope-select',
  DELETE_BUTTON = 'phone-edit__delete-button',
  CANCEL_BUTTON = 'phone-edit__cancel-button',
  SAVE_BUTTON = 'phone-edit__save-button',
}

export enum PHONE_EDIT_VALIDATION_ERROR {
  REQUIRED = 'REQUIRED',
  INCORRECT_VALUE = 'INCORRECT_VALUE',
}
